export default "__VITE_ASSET__DzCui5YL__"